import { format } from "date-fns";
import { Table } from "react-bootstrap";
import { ApproveCheckIcon } from "../Icons";
import ModalLoader from "../utils/ModalLoader";

// Extracted VendorListTable component
export function VendorListTable({
  vendorRFQ,
  isFetching,
  activeTableIndex,
  selectedID,
  setSelectedID,
  setActiveTableIndex,
  showRFQ,
  setVendorAttachments,
  showRFQTable,
  setSelectedFilledForm,
}) {
  return (
    <div className="px-md-4">
      <div className="row">
        <Table borderless striped className="product-table">
          <thead>
            <tr>
              <th>S/N</th>
              <th>Vendor</th>
              <th>Date</th>
              <th />
            </tr>
          </thead>

          {!isFetching ? (
            <tbody>
              {vendorRFQ.map((vendor, index) => (
                <tr
                  key={index}
                  className={`p-cursor ${
                    activeTableIndex === index ? "active-row-blue" : ""
                  }`}
                  onClick={() => {
                    setSelectedID(vendor.id);
                    setActiveTableIndex(index);
                    if (vendor.FormID && vendor.childFormId) {
                      showRFQ(vendor.FormID, vendor.childFormId);
                    } else {
                      setVendorAttachments([]);
                      showRFQTable(vendor.vendor, vendor.RFQId, vendor.QuoteId);
                      setSelectedFilledForm(null);
                    }
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{vendor?.VendorsQuotes?.CompanyName}</td>
                  <td>
                    {vendor?.Date_Log &&
                      format(new Date(vendor?.Date_Log), "dd MMM, yyyy")}
                  </td>
                  <td>
                    {(selectedID === vendor.id || vendor?.selectedItem) && (
                      <ApproveCheckIcon />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <ModalLoader show />
          )}
        </Table>
      </div>
    </div>
  );
}
